import Phaser from "phaser";
import ConferenceGame from "../ConferenceGame";
import DataProvider from "./DataProvider";
import {EventIntf} from "../ServerTypes";

export default class VenueDefinition {
    venueDataProvider: VenueDataProvider

    constructor(public event: EventIntf) {
        this.venueDataProvider = new VenueDataProvider(event)
    }

    preload(scene: Phaser.Scene): void {
    }

    postload(scene: Phaser.Scene): void {
    }

    createScenes(gameHost: ConferenceGame): Phaser.Scene[] {
        return []
    }

    venueValue(key: string): any {
        return this.venueDataProvider.getValue(key)
    }

    callRefresh() {
        this.venueDataProvider.callRefresh()
    }

    videoAdminPanel(forRoom: string):VideoRoomInfo {
        return new VideoRoomInfo("main_stream", "Main Video Stream")
    }
}

export class VideoRoomInfo {
    constructor(public roomKey:string, public roomName:string) {}
}

export class VenueDataProvider extends DataProvider {
    private event: EventIntf
    private venueData: VenueValueDefinitions = {}
    private staticData: VenueValueDefinitions = {}

    constructor(event: EventIntf) {
        super();
        this.event = event
        this.resetData(event);
    }

    callRefresh() {
        this.refreshData(this.event.id)
    }

    private resetData(event: EventIntf) {
        const venueData = JSON.parse(event.venueData)
        const static_venue_data = JSON.parse(event.static_venue_data)
        this.update(venueData, static_venue_data)
    }

    private refreshData(eventId: number) {
        fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(event => {
                this.resetData(event)
            })
    }

    private update(venueData: VenueValueDefinitions, staticData: VenueValueDefinitions) {
        this.venueData = venueData
        this.staticData = staticData
        this.call()
        this.dataLoaded = true
    }

    getValue(key: string): any {
        let val = this.venueData[key];
        return val ? val : this.staticData[key]
    }
}

export interface VenueValueDefinitions {
    [index: string]: any;
}
